import { useQuery } from "@tanstack/react-query";
import type { BusinessListOutput } from "@wcp/shared";
import { apiFetch } from "../../lib/api.js";

export interface BusinessView {
  id: string;
  slug: string;
  name: string;
  phoneNumberId: string;
  displayName: string;
  accent: string;
  tier: number;
  quality: "high" | "medium" | "low" | "unknown";
  connected: boolean;
}

export function useBusinesses() {
  return useQuery<BusinessView[]>({
    queryKey: ["businesses"],
    queryFn: async () => {
      const res = await apiFetch<BusinessListOutput & { businesses: BusinessView[] }>(
        "/api/v1/businesses",
      );
      return res.businesses as BusinessView[];
    },
    staleTime: 5 * 60_000,
  });
}
